import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'section-summary';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'p', { class: ['section-summary wok--body-long-02', ctx.data.staticClass] }, [
                ctx.slots().default
            ]
        )
    }
}